import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import type { LegalDocument } from "@-/dev.improve.haniverse.lib.legal";
import { View } from "@-/com.npmjs.react-native";
import { LegalSection } from "#legal-section";

/**
 * A legal document's body — title, revision date, intro and sections — with no scroll container
 * of its own so callers can host it in a page `ScrollView` or a `BottomSheetScrollView`.
 */
export function LegalDocumentBody({ document }: { document: LegalDocument }) {
  return (
    <View className="gap-6">
      <View className="gap-3">
        <Text className="text-left text-foreground" variant="h1">
          {document.title}
        </Text>
        <Text selectable={true} variant="muted">
          Last updated: {document.lastUpdated}
        </Text>
        <Text className="text-muted-foreground" selectable={true} variant="p">
          {document.intro}
        </Text>
      </View>

      {document.sections.map((section) => (
        <LegalSection key={section.title} section={section} />
      ))}
    </View>
  );
}
